<template>
  <div class="team-page">
    <div class="top-menu">
      <div class="top">人工智能与机器视觉实验室</div>
      <div class="blank"></div>
      <div class="menu">
        <div class="menu-detail" @click="jumpToHome">首页</div>
        <div class="menu-detail" @click="jumpToTutor">导师风采</div>
        <div class="menu-detail" @click="jumpToTeam">科研团队</div>
        <div class="menu-detail" @click="jumpToPaper">论文成果</div>
        <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
        <div class="menu-detail" @click="jumpToDownload">文件下载</div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
        <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
      </div>
    </div>
    <div class="blank"></div>
    <div class="page-content">
      <div class="lab">
        <div class="lab-title">研究生招生要求</div>
        <div class="lab-word">
          <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        具备吃苦耐劳的精神，能耐得住寂寞，对科学研究具有浓厚的兴趣；</div>
          <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        具备扎实的数学基础、较好的编程能力、熟练的英语听说读写能力（六级通过者优先）；</div>
          <div class="paper-block-word-item">
                        <i class="iconfont icon-yuandianzhong"></i>
                        本科专业以计算机类、自动化类、电子信息类、应用数学类为主； </div>
        </div>
        <div class="blank"></div>
      </div>
      <div class="team">
        <div class="team-title">团队成员</div>
        <div class="team-content">
          <div class="boshi">
            <div class="jiaoshi-title">团队教师</div>
            <div class="jiaoshi-content"></div>
              <div class="jiaoshi-content-item">杜晓刚（副教授）</div>
              <div class="jiaoshi-content-item">王营博（讲师）</div>
              <div class="jiaoshi-content-item">刘统飞（讲师）</div>
              <div class="jiaoshi-content-item">何熙（讲师）</div>
          </div>
          <div class="boshi">
            <div class="boshi-title">在读博士</div>
            <div class="boshi-content">
              <div class="boshi-content-item">
              刘鹏、薛丁华、闵重丹
              </div>
            </div>
          </div>
          <div class="shuoshi">
            <div class="shuoshi-title">在读硕士</div>
            <div class="shuoshi-content"></div>
                <div class="shuoshi-content-item">  21级研究生：孙瑞、张月、翟钰杰、刘乐、高阳峄、张少乐、张峻铭</div>
                <div class="shuoshi-content-item">  22级研究生：文思佳、许叶彤、王毅、宋文彪、于松岩、刘博</div>
                <div class="shuoshi-content-item">  23级研究生：杨子瑶、林少雄、姜由涛、刘少庆、周琼、杜方育</div>
          </div>
          <div class="baoyan">
            <div class="baoyan-title">保研学生</div>
            <div class="baoyan-content">
              <div class="baoyan-content-item">
              </div>
            </div>
          </div>
          <div class="biye">
            <div class="biye-title">毕业学生</div>
            <div class="biye-content">
                <div class="tutor-information-content">
                <div class="biye-infomation">17级毕业研究生：</div>
                <div class="biye-infomation">  张肖，中国电信集团有限公司</div>
                <div class="biye-infomation">  连倩，中国电信集团有限公司</div>
                <div class="biye-infomation">  加小红（博士），兰州交通大学</div>
                <div class="biye-infomation">18级毕业研究生：</div>
                <div class="biye-infomation">  张宇啸，迈瑞医疗国际股份有限公司</div>
                <div class="biye-infomation">  李云彤，中国联合通信有限公司</div>
                <div class="biye-infomation">  卢敏飞，陕西大医医疗器械有限公司</div>
                <div class="biye-infomation">  周文政，中国联合通信有限公司</div>
                <div class="biye-infomation">  任华妮，西安比亚迪汽车有限公司</div>
                <div class="biye-infomation">19级毕业研究生：</div>
                <div class="biye-infomation">  王日升，国家计算机网络应急技术处理协调中心</div>
                <div class="biye-infomation">  王洁，杭州长川科技股份有限公司</div>
                <div class="biye-infomation">  洪璐敏子，小米科技有限责任公司</div>
                <div class="biye-infomation">  李林泽，西安翔腾微电子科技有限公司</div>
                <div class="biye-infomation">20级毕业研究生：</div>
                <div class="biye-infomation">  张栋，西安翔腾微电子科技有限公司</div>
                <div class="biye-infomation">  尚佳童，商洛学院</div>
                <div class="biye-infomation">  耿信哲，西安土豆数据科技有限公司</div>
                <div class="biye-infomation">  苏建，深信服科技股份有限公司</div>
                <div class="biye-infomation">  陈琦，宁夏银川市金凤区委员会组织部</div>
                <div class="biye-infomation">  王泽轩，中国中车集团有限公司</div>
                <div class="biye-infomation">  雷俊超，中国建设银行</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
         <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    methods: {
      jumpToHome() {
        this.$router.push({
          name: "home",
        });
      },
      jumpToTutor() {
        this.$router.push({
          name: "tutor",
        });
      },
      jumpToTeam() {
        this.$router.push({
          name: "team",
        });
      },
      jumpToPaper() {
        this.$router.push({
          name: "paper",
        });
      },
      jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
      jumpToDownload() {
        this.$router.push({
            name: "download",
        });
      },
      jumpToInnovation() {
        this.$router.push({
            name: "innovation",
        });
      },
      jumpToService() {
        this.$router.push({
            name: "service",
        });
      },
      jumpToInfluence_Contribution() {
        this.$router.push({
          name: "influence_contribution",
        });
      },
    },
  };
</script>

<style scoped>
  .tutor-page {
    width: 100%;
    height: 100%;
    background-color: #fffef9;
    display: flex;
    flex-direction: column;
  }

  .top-menu {
    width: 100%;
  }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }


  .menu-detail:hover {
    background-color: #dfe8ed;
  }

  .page-content {
    /* width: 80%; */
    padding: 0 100px;
  }

  .lab {
    padding: 30px 0;
  }

  .lab-title {
    line-height: 50px;
    font-size: 22px;
  }

  .lab-word {
    line-height: 30px;
    padding-left: 20px;
    padding-bottom: 25px;
  }

  .team {}

  .team-title {
    line-height: 50px;
    font-size: 22px;
  }

  .team-content {}

.jiaoshi{
  padding-left: 20px;
}
.jiaoshi-title{
  line-height: 50px;
  font-size: 20px;
}
.jiaoshi-content{
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.jiaoshi-content-item{
  padding: 0 60px 20px 0;
  font-size: 18px;
  padding-bottom: 20px;
  padding-left: 80px;
}

.boshi{
  padding-left: 20px;
}
.boshi-title{
  line-height: 50px;
  font-size: 20px;
}
.boshi-content{
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.boshi-content-item{
  padding: 0 60px 20px 0;
  font-size: 18px;
}
.shuoshi{
  padding-left: 20px;
  font-size: 20px;
}
.shuoshi-title{
  line-height: 50px;
  font-size: 20px;
}
.shuoshi-content{
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.shuoshi-content-item{
  padding: 0 60px 20px 0;
  font-size: 18px;
  padding-bottom: 20px;
  padding-left: 80px;
}
.baoyan{
  padding-left: 20px;
}
.baoyan-title{
  line-height: 50px;
  font-size: 20px;
}
.baoyan-content{
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.baoyan-content-item{
  padding: 0 60px 20px 0;
}
.biye-infomation {
  padding-bottom: 10px;
}
.biye{
  padding-left: 20px;
}
.biye-title{
  line-height: 50px;
  font-size: 20px;
}
.biye-content{
  display: flex;
  flex-direction: row;
  padding-left: 80px;
  padding-top: 10px;
  flex-wrap: wrap;
}
.biye-content-item{
  padding: 0 60px 20px 0;
  font-size: 17px;
}
.item-img {
    height: 280px;
    width: 200px;
  }
  .item-name{
    line-height: 30px;
    padding-left: 80px;
  }
  .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
    }
</style>